import React, { useEffect, useRef, useState } from "react";
import BigLogo from "../../components/bigLogo/BigLogo";
import { UserService } from "../../services/UserService";
import ResultBoard from "@publicPortal/components/resultBoard/ResultBoard";
import { VerifyRequest } from "@shared/mirage/core/contracts/User";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";

const VerifyEmail = () => {
    const [emailVerificationSuccess, setEmailVerificationSuccess] = useState<any>(null);
    const emailVerificationCompleted = useRef(false);
    const pp = new PublicPortalRoutingService();
    // useRef in this case is a way around React.StrictMode to not fire multiple api calls
    // https://stackoverflow.com/questions/72238175/useeffect-is-running-twice-on-mount-in-react/72238236#72238236

    async function handleEmailVerification() {
        const query = window.location.search;
        const urlParams = new URLSearchParams(query);
        const token = urlParams.get("t");

        if (token && !emailVerificationCompleted.current) {
            emailVerificationCompleted.current = true;
            const verifyEmailRequest: VerifyRequest = { token: token };

            const userService = new UserService();
            const verifyEmailResponse = await userService.verifyEmail(verifyEmailRequest);
            const verifyEmailSuccess = verifyEmailResponse.success;
            setEmailVerificationSuccess(verifyEmailSuccess);
        } else if (!emailVerificationCompleted.current) {
            emailVerificationCompleted.current = true;
            setEmailVerificationSuccess(false);
        }
    }

    useEffect(() => {
        handleEmailVerification();
    });

    return (
        <>
            <BigLogo />
            <ResultBoard
                loading={emailVerificationCompleted.current === false ? true : false}
                success={emailVerificationCompleted.current === false ? false : emailVerificationSuccess}
                message={emailVerificationSuccess === false ? "Invalid code." : "Your account has been activated."}
                headerText={"Email activation"}
                buttonLabel={"Back to Login"}
                buttonNavTo={pp.LoginRoute()}
            />
            ;{}
        </>
    );
};

export default VerifyEmail;
